/* eslint import/prefer-default-export: 0 */
import { call, fork, select, put, take } from 'redux-saga/effects'

import { getIn } from 'utils'
import { api } from 'services'

import { SET_FIELD } from 'ddiForm/constants'
import { getEntityAsync } from 'ddiForm/MasterScreen/actions'
import {
  getFormSelector,
  getMapResponse,
  getSelectedTabsFromState
} from 'ddiForm/utils'

import { listAudits } from './actions'

export function* wrapAuditDataAccess(form) {
  const formState = yield select(getFormSelector(form))
  const dataId = getIn(formState, 'fields.dataId.value')
  const showAllAudits = getIn(formState, 'fields.showAllAudits.value') || false

  try {
    yield fork(
      listAuditsProcess,
      form,
      { dataId, showAll: showAllAudits },
      true
    )
  } catch (e) {
    throw new Error(e)
  }
}

export function* additionalAuditsDataFlagListener(formListener) {
  while (true) {
    const {
      payload: { propertyName },
      meta: { form }
    } = yield take(SET_FIELD)
    if (form === formListener && propertyName === 'showAllAudits') {
      const apiParams = yield call(getApiParams, form)
      yield fork(listAuditsProcess, form, apiParams)
    }
  }
}

export function* getApiParams(form) {
  const formState = yield select(getFormSelector(form))
  const dataId =
    getIn(formState, 'fields.dataId.value') || getIn(formState, 'values.dataId')
  const showAll = getIn(formState, 'fields.showAllAudits.value') || false
  const guid = getIn(formState, 'guid')
  let apiParams = {}

  if (form === 'contact' || form === 'customerShipTo') {
    const parentId = getIn(formState, 'values.parent.parentId')
    const parentType = getIn(formState, 'values.parent.parentType')
    apiParams = { dataId, parentId, parentType, showAll }
  } else {
    apiParams = { dataId, showAll, guid }
  }

  return apiParams
}

export function* listAuditsProcess(form, apiParams, isAccessAttempt = false) {
  const formState = yield select(getFormSelector(form))
  const guid = getIn(formState, 'guid')
  const { dataId } = apiParams
  const groupNames = getSelectedTabsFromState(formState) || ['audit']

  if (!dataId) {
    return
  }

  yield put(getEntityAsync.request(form))

  const R = yield call(api.getAudits, {
    ...apiParams,
    groupNames,
    guid,
    form: form.match(/salesOrder/) ? 'salesOrder' : form
  })

  if (R.response) {
    const mapResponse = yield getMapResponse({ formState, tabIds: groupNames })
    const response = mapResponse({
      response: R.response,
      tabIds: groupNames,
      formState,
      groupNames
    })
    yield put(getEntityAsync.success(response, form))
  } else {
    yield put(listAudits.failure(R.error, form))
  }
}
